var render, staticRenderFns
import script from "./DsioEngine.vue?vue&type=script&lang=js&"
export * from "./DsioEngine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/su_laetis/workspaces/structure-wordpress-php8/httpsdocs/plugins/lae-elementor-diffusio/libs/diffusio/ressources/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8578e4d0')) {
      api.createRecord('8578e4d0', component.options)
    } else {
      api.reload('8578e4d0', component.options)
    }
    
  }
}
component.options.__file = "js/components/DsioEngine.vue"
export default component.exports